import {
  GridContainer,
  GridItem,
  isArrayNotEmpty,
  NomenclatureAutocompleteFormField,
  InputFormField,
} from "@duosoftbg/nacid-components";
import { nationalUniversitiesDataThunk } from "../../../../../../store/redux/slice/AppData/nationalUniversitiesData";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import UniversityInfo from "../university/UniversityInfo";
import { useFormContext, useWatch } from "react-hook-form";

const UniversityRepresentativeFormFields = () => {
  const { getValues } = useFormContext();
  const thunkState = useAppSelector((state) => {
    return state.AppData.nationalUniversitiesData;
  });

  useWatch({ name: "representativeType" });
  useWatch({ name: "representedUniversity" });

  const selectSelectedOption = (fieldValue) => {
    if (fieldValue && isArrayNotEmpty(thunkState.data)) {
      return thunkState.data.find((element) => element.id === fieldValue);
    }
    return null;
  };

  return (
    <>
      <GridContainer spacing={4} mt={0}>
        <GridItem>
          <InputFormField fieldName={"representativeCapacity"} labelCode={"l.representativeCapacity"} required={true} />
        </GridItem>
        <GridItem sm={12} md={12}>
          <NomenclatureAutocompleteFormField
            onlyActive
            required={true}
            fieldName={"representedUniversity"}
            labelCode={"l.university"}
            thunkFn={nationalUniversitiesDataThunk}
            thunkState={thunkState}
            initialValue={getValues().representedUniversity}
            previousOptionValueFn={selectSelectedOption}
          />
        </GridItem>
      </GridContainer>

      {selectSelectedOption(getValues().representedUniversity) && (
        <UniversityInfo university={selectSelectedOption(getValues().representedUniversity)} />
      )}
    </>
  );
};
export default UniversityRepresentativeFormFields;
